import { useCallback, useEffect, useRef, useState } from "react";

// Aborts the previous in-flight request whenever a new one starts, so stale responses never overwrite fresh ones.
export function useLatestRequest() {
  const ref = useRef(null);
  useEffect(() => () => ref.current?.abort(), []);
  return useCallback(() => { ref.current?.abort(); ref.current = new AbortController(); return ref.current.signal; }, []);
}

export const isCanceled = (e) => e?.code === "ERR_CANCELED" || e?.name === "CanceledError" || e?.name === "AbortError";

export function useDebounced(value, ms = 350) {
  const [v, setV] = useState(value);
  useEffect(() => { const t = setTimeout(() => setV(value), ms); return () => clearTimeout(t); }, [value, ms]);
  return v;
}
